import URL from "core/resources/urls";
import http from "infra/http";
import { useMutation } from "react-query";

export interface CreateDestinatarioRequest {
  nome: string;
  email: string;
  telefone: string;
  ativo: boolean;
}

export default function useCreateDestinatario() {
  return useMutation({
    mutationFn: async (data: CreateDestinatarioRequest) => {
      const response = await http.post(URL.CONFIGURACAO_NOTIFICACOES.OBTER_DESTINATARIOS, data);
      return response.data;
    },
  });
}
